import { SelectionModel } from "@angular/cdk/collections";
import { DatePipe, Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { faListAlt } from "@fortawesome/free-solid-svg-icons";
import { DateTime } from "luxon";
import { Observable, Subscription, of, throwError } from "rxjs";
import { catchError, map, startWith } from "rxjs/operators";
import { EletronicTransferStatus } from "../../enum/eletronic-transfer-status.enum";
import { MenuConstants } from "../../infrastructure/MenuConstants";
import { AccountManager } from "../../model/domain/AccountManager";
import { Contracted } from "../../model/domain/Contracted";
import { CurrencyTerm } from "../../model/domain/CurrencyTerm";
import {
  DialogSize,
  MarketType,
  OperationType as OperationTypeEnum,
  OperationTypeQuota,
  Ticket,
  TicketStatus,
  TicketType as TicketTypeEnum,
  WorkflowStatus,
} from "../../model/domain/Entity";
import { Exchange } from "../../model/domain/Exchange";
import { Expenses } from "../../model/domain/Expenses";
import { FundQuota } from "../../model/domain/FundQuota";
import { Futures } from "../../model/domain/Futures";
import { LiabilitiesModel } from "../../model/domain/LiabilitiesModel";
import { Loan } from "../../model/domain/Loan";
import { Margin } from "../../model/domain/Margin";
import {
  FilterDateType,
  MonitorFilter,
} from "../../model/domain/MonitorFilter";
import { PagedList } from "../../model/domain/PagedList";
import { PrivateFixedIncome } from "../../model/domain/PrivateFixedIncome";
import { PublicFixedIncome } from "../../model/domain/PublicFixedIncome";
import { StructuredOperationModel } from "../../model/domain/StructuredOperationModel";
import { SwapCetip } from "../../model/domain/SwapCetip";
import { NamedType } from "../../model/domain/Tipo";
import { Transfer } from "../../model/domain/Transfer";
import { VariableIncome } from "../../model/domain/VariableIncome";
import { AuthService } from "../../services/auth.service";
import { CutoffService } from "../../services/cutoff.service";
import { DialogService } from "../../services/dialog.service";
import { DomainService, TicketType } from "../../services/domain.service";
import { DownloadService } from "../../services/download.service";
import { LoaderService } from "../../services/loader.service";
import { SecurityService } from "../../services/security.service";
import { SnackbarService } from "../../services/snackbar.service";
import { TicketService } from "../../services/ticket.service";
import { ValidatorService } from "../../services/validator.service";
import { Roles } from "../auth/auth.role";
import { TicketCutoffTicketPermission } from "../cutoff/ticket-cutoff-type.model";
import { StructuredOperationOrder } from "./../../model/domain/StructuredOperationOrder";
import { OperationType, SettlementType } from "./../../services/domain.service";

@Component({
  selector: "app-monitores",
  templateUrl: "./monitores.component.html",
  styleUrls: ["./monitores.component.scss"],
})
export class MonitoresComponent implements OnInit {
  constructor(
    private ticketService: TicketService,
    private domainService: DomainService,
    private authService: AuthService,
    private dialogService: DialogService,
    private snackBarService: SnackbarService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public validator: ValidatorService,
    private downloadService: DownloadService,
    private loaderService: LoaderService,
    private securityService: SecurityService,
    private datePipe: DatePipe,
    private cutoffService: CutoffService
  ) {}

  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  ActiveTicketId = 0;
  TicketStatus = TicketStatus;
  TicketTypeEnum = TicketTypeEnum;
  MenuConstants = MenuConstants;

  //FontAwsome
  faListAlt = faListAlt;

  // Filtros
  monitorFilter: MonitorFilter = new MonitorFilter();
  AccountManagerSelected: AccountManager;
  IsTicketTypeFilter: boolean;
  today: Date = new Date();
  filterDateTypes = [
    { name: "Data de Operação", value: FilterDateType.OperationDate },
    { name: "Data de Liquidação", value: FilterDateType.SettlementDate },
  ];

  // Paginação
  defaultPage = 1;
  defaultPageSize = 10;
  pageSizeSelected = this.defaultPageSize;

  // #region Variáveis de Paginação
  quotaCurrentPage: number = this.defaultPage;
  quotaPageSize: number = this.defaultPageSize;
  quotaTotalPages: number = null;
  quotaTotalItems: number = null;
  quotaListedPages: any[];
  quotaFirstItemOnPage: number;
  quotaLastItemOnPage: number;

  cetipCurrentPage: number = this.defaultPage;
  cetipPageSize: number = this.defaultPageSize;
  cetipTotalPages: number = null;
  cetipTotalItems: number = null;
  cetipListedPages: any[];
  cetipFirstItemOnPage: number;
  cetipLastItemOnPage: number;

  selicCurrentPage: number = this.defaultPage;
  selicPageSize: number = this.defaultPageSize;
  selicTotalPages: number = null;
  selicTotalItems: number = null;
  selicListedPages: any[];
  selicFirstItemOnPage: number;
  selicLastItemOnPage: number;

  contractedCurrentPage: number = this.defaultPage;
  contractedPageSize: number = this.defaultPageSize;
  contractedTotalPages: number = null;
  contractedTotalItems: number = null;
  contractedListedPages: any[];
  contractedFirstItemOnPage: number;
  contractedLastItemOnPage: number;

  futuresCurrentPage: number = this.defaultPage;
  futuresPageSize: number = this.defaultPageSize;
  futuresTotalPages: number = null;
  futuresTotalItems: number = null;
  futuresListedPages: any[];
  futuresFirstItemOnPage: number;
  futuresLastItemOnPage: number;

  swapCetipCurrentPage: number = this.defaultPage;
  swapCetipPageSize: number = this.defaultPageSize;
  swapCetipTotalPages: number = null;
  swapCetipTotalItems: number = null;
  swapCetipListedPages: any[];
  swapCetipFirstItemOnPage: number;
  swapCetipLastItemOnPage: number;

  marginCurrentPage: number = this.defaultPage;
  marginPageSize: number = this.defaultPageSize;
  marginTotalPages: number = null;
  marginTotalItems: number = null;
  marginListedPages: any[];
  marginFirstItemOnPage: number;
  marginLastItemOnPage: number;

  currencyTermCurrentPage: number = this.defaultPage;
  currencyTermPageSize: number = this.defaultPageSize;
  currencyTermTotalPages: number = null;
  currencyTermTotalItems: number = null;
  currencyTermListedPages: any[];
  currencyTermFirstItemOnPage: number;
  currencyTermLastItemOnPage: number;

  variableIncomeCurrentPage: number = this.defaultPage;
  variableIncomePageSize: number = this.defaultPageSize;
  variableIncomeTotalPages: number = null;
  variableIncomeTotalItems: number = null;
  variableIncomeListedPages: any[];
  variableIncomeFirstItemOnPage: number;
  variableIncomeLastItemOnPage: number;

  transferCurrentPage: number = this.defaultPage;
  transferPageSize: number = this.defaultPageSize;
  transferTotalPages: number = null;
  transferTotalItems: number = null;
  transferListedPages: any[];
  transferFirstItemOnPage: number;
  transferLastItemOnPage: number;

  loanCurrentPage: number = this.defaultPage;
  loanPageSize: number = this.defaultPageSize;
  loanTotalPages: number = null;
  loanTotalItems: number = null;
  loanListedPages: any[];
  loanFirstItemOnPage: number;
  loanLastItemOnPage: number;

  exchangeCurrentPage: number = this.defaultPage;
  exchangePageSize: number = this.defaultPageSize;
  exchangeTotalPages: number = null;
  exchangeTotalItems: number = null;
  exchangeListedPages: any[];
  exchangeFirstItemOnPage: number;
  exchangeLastItemOnPage: number;

  expensesCurrentPage: number = this.defaultPage;
  expensesPageSize: number = this.defaultPageSize;
  expensesTotalPages: number = null;
  expensesTotalItems: number = null;
  expensesListedPages: any[];
  expensesFirstItemOnPage: number;
  expensesLastItemOnPage: number;

  liabilitiesCurrentPage: number = this.defaultPage;
  liabilitiesPageSize: number = this.defaultPageSize;
  liabilitiesTotalPages: number = null;
  liabilitiesTotalItems: number = null;
  liabilitiesListedPages: any[];
  liabilitiesFirstItemOnPage: number;
  liabilitiesLastItemOnPage: number;

  structuredCurrentPage: number = this.defaultPage;
  structuredPageSize: number = this.defaultPageSize;
  structuredTotalPages: number = null;
  structuredTotalItems: number = null;
  structuredListedPages: any[];
  structuredFirstItemOnPage: number;
  structuredLastItemOnPage: number;

  structuredOrderCurrentPage: number = this.defaultPage;
  structuredOrderPageSize: number = this.defaultPageSize;
  structuredOrderTotalPages: number = null;
  structuredOrderTotalItems: number = null;
  structuredOrderListedPages: any[];
  structuredOrderFirstItemOnPage: number;
  structuredOrderLastItemOnPage: number;
  // #endregion Variáveis de Paginação

  Quotas: FundQuota[] = [];
  PrivateFixedIncome: PrivateFixedIncome[] = [];
  PublicFixedIncome: PublicFixedIncome[] = [];
  Contracted: Contracted[] = [];
  Futures: Futures[] = [];
  SwapCetip: SwapCetip[] = [];
  Margin: Margin[] = [];
  CurrencyTerm: CurrencyTerm[] = [];
  VariableIncome: VariableIncome[] = [];
  Transfer: Transfer[] = [];
  Loan: Loan[] = [];
  Exchange: Exchange[] = [];
  Expenses: Expenses[] = [];
  Liabilities: LiabilitiesModel[] = [];
  StructuredOperations: StructuredOperationModel[] = [];
  StructuredOrder: StructuredOperationOrder[] = [];

  SelectionQuotas = new SelectionModel<FundQuota>(true, []);
  SelectionPrivateFixedIncome = new SelectionModel<PrivateFixedIncome>(
    true,
    []
  );
  SelectionPublicFixedIncome = new SelectionModel<PublicFixedIncome>(true, []);
  SelectionContracted = new SelectionModel<Contracted>(true, []);
  SelectionFutures = new SelectionModel<Futures>(true, []);
  SelectionSwapCetip = new SelectionModel<SwapCetip>(true, []);
  SelectionMargin = new SelectionModel<Margin>(true, []);
  SelectionCurrencyTerm = new SelectionModel<CurrencyTerm>(true, []);
  SelectionVariableIncome = new SelectionModel<VariableIncome>(true, []);
  SelectionTransfer = new SelectionModel<Transfer>(true, []);
  SelectionLoan = new SelectionModel<Loan>(true, []);
  SelectionExchange = new SelectionModel<Exchange>(true, []);
  SelectionExpenses = new SelectionModel<Expenses>(true, []);
  SelectionLiabilities = new SelectionModel<LiabilitiesModel>(true, []);
  SelectionStructured = new SelectionModel<StructuredOperationModel>(true, []);
  SelectionStructuredOrder = new SelectionModel<StructuredOperationOrder>(
    true,
    []
  );

  ListaStatus: NamedType<any>[];
  TicketTypes: TicketType[];
  AccountManagers: AccountManager[];
  filteredAccountManagers: Observable<AccountManager[]>;
  WorkflowStatus: NamedType<any>[];

  WorkflowStatusDescription: { [x: number]: string } = {};
  OperationTypesDescription: { [x: number]: string } = {};
  QuotaOperationTypesDescription: { [x: number]: string } = {};
  SettlemenTypesDescription: { [x: number]: string } = {};
  MarketTypesDescription: { [x: number]: string } = {};

  ListOperationTypes: OperationType[] = [];
  ListSettlementTypes: SettlementType[] = [];

  hasElectronicTransfer: boolean;

  electronicTransferTimeLimit: any;

  ColumnsQuota: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "settlementTypeId",
    "operationValue",
    "fundName",
    "accountManagerName",
    "accountManagerDocument",
    "isInternalFund",
    "counterpartName",
    "cetipAccount",
    "isCetipVoice",
    "cetipVoiceId",
    "mnemonicCode",
    "counterpartCetipAccount",
    "amount",
    "quotaValue",
    "fundType",
    "portfolioAccount",
    "fundBank",
    "fundBranch",
    "fundAccount",
    "isNewFund",
    "elapsedTime",
    "lastStatusDate",
  ];

  ColumnsPrivateFixedIncome: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "settlementTypeId",
    "operationValue",
    "counterpartName",
    "accountManagerName",
    "accountManagerDocument",
    "assetType",
    "assetCode",
    "portfolioCetipAccount",
    "unitPrice",
    "amount",
    "expirationDate",
    "counterpartCetipAccount",
    "portfolioAccount",
    "elapsedTime",
    "lastStatusDate",
  ];

  ColumnsPublicFixedIncome: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "settlementTypeId",
    "operationValue",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioSelicAccount",
    "unitPrice",
    "amount",
    "security",
    "securityId",
    "expirationDate",
    "counterpartName",
    "counterpartSelicAccount",
    "portfolioAccount",
    "command",
    "elapsedTime",
  ];

  ColumnsContracted: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "counterpartName",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioSelicAccount",
    "returnDate",
    "valueOutward",
    "valueReturn",
    "issueTax",
    "security",
    "securityId",
    "expirationDate",
    "portfolioAccount",
    "command",
    "elapsedTime",
  ];

  ColumnsFutures: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioB3Account",
    "tradingDate",
    "broker",
    "brokerCode",
    "paperCode",
    "amount",
    "portfolioAccount",
    "elapsedTime",
  ];

  ColumnsSwapCetip: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationValue",
    "counterpartName",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioCetipAccount",
    "counterpartCetipAccount",
    "portfolioAccount",
    "elapsedTime",
  ];

  ColumnsMargin: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "operationValue",
    "counterpartName",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioClearingAccount",
    "marketTypeId",
    "amount",
    "unitPrice",
    "securityName",
    "securityCode",
    "expirationDate",
    "counterpartClearingAccount",
    "command",
    "portfolioAccount",
    "elapsedTime",
    "bank",
    "branch",
    "account",
    "lastStatusDate",
  ];

  ColumnsCurrencyTerm: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "operationValue",
    "counterpartName",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioCetipAccount",
    "counterpartCetipAccount",
    "portfolioAccount",
    "elapsedTime",
  ];

  ColumnsVariableIncome: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "accountManagerName",
    "accountManagerDocument",
    "b3Account",
    "brokerCode",
    "buyTotal",
    "sellTotal",
    "total",
  ];

  ColumnsTransfer: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "operationTypeId",
    "operationValue",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "receiverBank",
    "receiverBranch",
    "receiverAccount",
    "elapsedTime",
    "lastStatusDate",
  ];

  ColumnsLoan: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "broker",
    "loanType",
    "typeAction",
    "finalGraceDate",
    "operationTypeId",
    "elapsedTime",
  ];

  ColumnsExchange: string[] = [
    "actions",
    "id",
    "statusId",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "operationValue",
    "counterpartName",
    "accountManagerName",
    "accountManagerDocument",
    "currencyName",
    "currencyQuotation",
    "parityPl",
    "parityMtm",
    "settlementDate",
    "counterpartName",
    "tradingPlace",
    "settlementPlace",
    "appealDate",
    "expirationDate",
    "contractSaleSettlementDate",
    "currencyAmount",
    "elapsedTime",
  ];

  ColumnsExpenses: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationValue",
    "accountManagerName",
    "accountManagerDocument",
    "expenseType",
    "details",
    "elapsedTime",
  ];

  ColumnsLiabilities: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "settlementTypeId",
    "operationValue",
    "accountManagerName",
    "accountManagerDocument",
    "cetipAccount",
    "amount",
    "quotaValue",
    "portfolioAccount",
    "fundBank",
    "fundBranch",
    "fundAccount",
    "isNewFund",
    "elapsedTime",
    "lastStatusDate",
  ];

  ColumnsStructured: string[] = [
    "actions",
    "id",
    "statusId",
    "accountManagerName",
    "accountManagerDocument",
    "operationDate",
    "portfolioName",
    "portfolioDocument",
    // specifics
    "elapsedTime",
  ];

  ColumnsStructuredOrder: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "settlementTypeId",
    "operationValue",
    "assetType",
    "assetCode",
    "accountManagerName",
    "accountManagerDocument",
    "portfolioCetipAccount",
    "unitPrice",
    "amount",
    "expirationDate",
    "counterpartName",
    "counterpartCetipAccount",
    "portfolioAccount",
    "elapsedTime",
    "lastStatusDate",
  ];

  TicketRoleMap = {
    [TicketTypeEnum.Quota]: Roles.ViewMonitorFundQuota,
    [TicketTypeEnum.CETIP]: Roles.ViewMonitorPrivateFixedIncome,
    [TicketTypeEnum.SELIC]: Roles.ViewMonitorPublicFixedIncome,
    [TicketTypeEnum.Contracted]: Roles.ViewMonitorContracted,
    [TicketTypeEnum.Futures]: Roles.ViewMonitorFutures,
    [TicketTypeEnum.SwapCetip]: Roles.ViewMonitorSwapCetip,
    [TicketTypeEnum.Margin]: Roles.ViewMonitorMargin,
    [TicketTypeEnum.CurrencyTerm]: Roles.ViewMonitorCurrencyTerm,
    [TicketTypeEnum.VariableIncome]: Roles.ViewMonitorVariableIncome,
    [TicketTypeEnum.Transfer]: Roles.ViewMonitorTransfer,
    [TicketTypeEnum.Exchange]: Roles.ViewMonitorExchange,
    [TicketTypeEnum.Loan]: Roles.ViewMonitorLoan,
    [TicketTypeEnum.Expenses]: Roles.ViewExpensesMonitor,
    [TicketTypeEnum.Liabilities]: Roles.ViewLiabilitiesMonitor,
    [TicketTypeEnum.StructuredOperations]:
      Roles.ViewMonitorOperationStructured,
    [TicketTypeEnum.StructuredOperationOrder]:
      Roles.ViewStructuredOperationOrderMonitor,
  };

  TicketRoleCreateMap = {
    [TicketTypeEnum.Quota]: Roles.CreateTicketFundQuota,
    [TicketTypeEnum.CETIP]: Roles.CreateTicketPrivateFixedIncome,
    [TicketTypeEnum.SELIC]: Roles.CreateTicketPublicFixedIncome,
    [TicketTypeEnum.Contracted]: Roles.CreateTicketContracted,
    [TicketTypeEnum.Futures]: Roles.CreateTicketFutures,
    [TicketTypeEnum.SwapCetip]: Roles.CreateTicketSwapCetip,
    [TicketTypeEnum.Margin]: Roles.CreateTicketMargin,
    [TicketTypeEnum.CurrencyTerm]: Roles.CreateTicketCurrencyTerm,
    [TicketTypeEnum.VariableIncome]: Roles.CreateTicketVariableIncome,
    [TicketTypeEnum.Transfer]: Roles.CreateTicketTransfer,
    [TicketTypeEnum.Exchange]: Roles.CreateTicketExchange,
    [TicketTypeEnum.Loan]: Roles.CreateTicketLoan,
    [TicketTypeEnum.Expenses]: Roles.CreateExpensesTicket,
    [TicketTypeEnum.Liabilities]: Roles.CreateLiabilitiesTicket,
    [TicketTypeEnum.StructuredOperations]:
      Roles.CreateTicketStructuredOperations,
    [TicketTypeEnum.StructuredOperationOrder]:
      Roles.CreateStructuredOperationOrderTicket,
  };

  ngOnInit() {
    this.domainService.ListTicketTypes().subscribe((types) => {
      types.sort(function (a: any, b: any) {
        return a.name > b.name ? 1 : -1;
      });
      this.TicketTypes = types;
    });

    this.ticketService.getWorkflowStatus().subscribe((wfStatus) => {
      wfStatus[-1] = "Em Elaboração";
      this.WorkflowStatusDescription = wfStatus;
      const arrWfStatus = Object.keys(wfStatus).map((key) => ({
        id: +key,
        name: wfStatus[key],
      })) as any[];
      arrWfStatus.sort(function (a: any, b: any) {
        return a.name > b.name ? 1 : -1;
      });
      this.WorkflowStatus = arrWfStatus;
    });

    this.domainService.ListOperationTypes().subscribe((types) => {
      this.ListOperationTypes = types;
      const descriptions = {};
      types.forEach((t) => {
        descriptions[t.id] = t.name;
      });
      this.OperationTypesDescription = descriptions;
    });

    this.domainService.ListSettlementTypes().subscribe((types) => {
      this.ListSettlementTypes = types;
    });

    this.route.queryParams.subscribe((params) => {
      if (JSON.stringify(params) !== "{}") {
        this.fillFilter(params);
      } else {
        this.monitorFilter.dateType = FilterDateType.SettlementDate;
      }
    });

    if (this.monitorFilter.ticketType) {
      this.ActiveTicketId = this.monitorFilter.ticketType;
    }

    if (
      !this.monitorFilter.untilDate ||
      isNaN(this.monitorFilter.untilDate.getTime())
    ) {
      this.monitorFilter.untilDate = DateTime.local().toJSDate();
    }

    if (
      !this.monitorFilter.fromDate ||
      isNaN(this.monitorFilter.fromDate.getTime())
    ) {
      this.monitorFilter.fromDate = DateTime.local().toJSDate();
    }

    this.populate();

    if (this.QuotaOperationTypesDescription) {
      const descriptions = {};

      descriptions[OperationTypeQuota.Application] = "Aplicação";
      descriptions[OperationTypeQuota.Redemption] = "Resgate";
      descriptions[OperationTypeQuota.FullRedemption] = "Resgate Total";
      descriptions[OperationTypeQuota.Amortization] =
        "Recebimento de Amortização";
      descriptions[OperationTypeQuota.Deposit] = "Depósito";
      descriptions[OperationTypeQuota.Withdrawal] = "Retirada";

      this.QuotaOperationTypesDescription = descriptions;
    }

    this.domainService.ListSettlementTypes().subscribe((types) => {
      const descriptions = {};
      types.forEach((t) => {
        descriptions[t.id] = t.name;
      });
      this.SettlemenTypesDescription = descriptions;
    });

    this.domainService.ListMarketTypes().subscribe((types) => {
      const descriptions = {};
      types.forEach((t) => {
        descriptions[t.id] = t.name;
      });
      this.MarketTypesDescription = descriptions;
    });

    if (!this.isAccountManager()) {
      this.securityService.GetAccountManagers().subscribe((a) => {
        this.AccountManagers = a;
        this.filteredAccountManagers = this.frm.controls[
          "accountManager"
        ].valueChanges.pipe(
          startWith(""),
          map((value) => (typeof value === "string" ? value : value?.name)),
          map((value) => this._searchAccountManager(value))
        );
      });
    }

    if (!this.electronicTransferTimeLimit) {
      this.ticketService.getEletronicTransferTimeLimit().subscribe((res) => {
        this.electronicTransferTimeLimit = res;
      });
    }
  }

  fillFilter(params) {
    this.monitorFilter.dateType =
      params["dateType"] != null
        ? +params["dateType"]
        : FilterDateType.OperationDate;
    this.monitorFilter.fromDate = new Date(+params["fromDate"]);
    this.monitorFilter.untilDate = new Date(+params["untilDate"]);
    this.monitorFilter.statusId =
      params["statusId"] != null ? +params["statusId"] : null;
    this.monitorFilter.settlementTypeId =
      params["settlementTypeId"] != null ? +params["settlementTypeId"] : null;
    this.monitorFilter.operationTypeId =
      params["operationTypeId"] != null ? +params["operationTypeId"] : null;
    this.monitorFilter.ticketType =
      params["ticketType"] != null ? +params["ticketType"] : null;
    this.monitorFilter.ticketId = params["ticketId"];
    this.monitorFilter.accountManagerId = params["accountManagerId"];
    this.monitorFilter.fundCode = params["fundCode"];
    this.monitorFilter.fundName = params["fundName"];
    this.monitorFilter.fundCnpj = params["fundCnpj"];
  }

  sameGroupHasApproved(approvedGroupIds: any) {
    return this.authService.hasGroup(approvedGroupIds);
  }

  populate() {
    if (this.periodoError()) {
      this.snackBarService.open("Período inválido");
      return;
    }

    if (this.monitorFilter.ticketType) {
      this.load(this.monitorFilter.ticketType);
    } else {
      this.resetPaginators();

      this.loadQuotaPaged();
      this.loadCetipPaged();
      this.loadSelicPaged();
      this.loadContractedPaged();
      this.loadFuturesPaged();
      this.loadSwapCetipPaged();
      this.loadMarginPaged();
      this.loadCurrencyTermPaged();
      this.loadVariableIncomePaged();
      this.loadTransferPaged();
      this.loadLoanPaged();
      this.loadExchangePaged();
      this.loadExpensesPaged();
      this.loadLiabilitiesPaged();
      this.loadStructuredPaged();
      this.loadStructuredOrderPaged();

      this.IsTicketTypeFilter = false;
    }
  }

  load(ticketType: TicketTypeEnum = null, ignoreViewChanges: boolean = false) {
    switch (ticketType) {
      case TicketTypeEnum.Quota:
        this.pageSizeSelected = this.quotaPageSize;
        break;

      case TicketTypeEnum.CETIP:
        this.pageSizeSelected = this.cetipPageSize;
        break;

      case TicketTypeEnum.SELIC:
        this.pageSizeSelected = this.selicPageSize;
        break;

      case TicketTypeEnum.Contracted:
        this.pageSizeSelected = this.contractedPageSize;
        break;

      case TicketTypeEnum.Futures:
        this.pageSizeSelected = this.futuresPageSize;
        break;

      case TicketTypeEnum.SwapCetip:
        this.pageSizeSelected = this.swapCetipPageSize;
        break;

      case TicketTypeEnum.Margin:
        this.pageSizeSelected = this.marginPageSize;
        break;

      case TicketTypeEnum.CurrencyTerm:
        this.pageSizeSelected = this.currencyTermPageSize;
        break;

      case TicketTypeEnum.VariableIncome:
        this.pageSizeSelected = this.variableIncomePageSize;
        break;

      case TicketTypeEnum.Transfer:
        this.pageSizeSelected = this.transferPageSize;
        break;

      case TicketTypeEnum.Loan:
        this.pageSizeSelected = this.loanPageSize;
        break;

      case TicketTypeEnum.Exchange:
        this.pageSizeSelected = this.exchangePageSize;
        break;

      case TicketTypeEnum.Expenses:
        this.pageSizeSelected = this.expensesPageSize;
        break;

      case TicketTypeEnum.Liabilities:
        this.pageSizeSelected = this.liabilitiesPageSize;
        break;

      case TicketTypeEnum.StructuredOperations:
        this.pageSizeSelected = this.structuredPageSize;
        break;

      case TicketTypeEnum.StructuredOperationOrder:
        this.pageSizeSelected = this.structuredOrderPageSize;
        break;

      default:
        this.pageSizeSelected = this.defaultPage;
        break;
    }

    const params: any[] = [
      this.monitorFilter.dateType,
      this.monitorFilter.fromDate,
      this.monitorFilter.untilDate,
      this.monitorFilter.statusId,
      this.monitorFilter.operationTypeId,
      this.monitorFilter.settlementTypeId,
      this.monitorFilter.fundCode,
      this.monitorFilter.fundName,
      this.validator.sanitize(this.monitorFilter.fundCnpj || ""),
      this.monitorFilter.ticketId,
      this.monitorFilter.accountManagerId,
      this.defaultPage,
      this.pageSizeSelected,
    ];

    const methods: { [x: number]: () => Subscription } = {
      [TicketTypeEnum.Quota]: () =>
        this.mapTicketData(
          this.ticketService.FundQuota.listTicket<PagedList<FundQuota>>(
            ...params
          )
        ).subscribe((s) => {
          this.Quotas = s.results;
          this.renderPaginatorQuota(s);
        }),
      [TicketTypeEnum.CETIP]: () =>
        this.mapTicketData(
          this.ticketService.PrivateFixedIncome.listTicket(...params)
        ).subscribe((s) => {
          this.PrivateFixedIncome = s.results;
          this.renderPaginatorCetip(s);
        }),
      [TicketTypeEnum.SELIC]: () =>
        this.mapTicketData(
          this.ticketService.PublicFixedIncome.listTicket(...params)
        ).subscribe((s) => {
          this.PublicFixedIncome = s.results;
          this.renderPaginatorSelic(s);
        }),
      [TicketTypeEnum.Contracted]: () =>
        this.mapTicketData(
          this.ticketService.Contracted.listTicket(...params)
        ).subscribe((s) => {
          this.Contracted = s.results;
          this.renderPaginatorContracted(s);
        }),
      [TicketTypeEnum.Futures]: () =>
        this.mapTicketData(
          this.ticketService.Futures.listTicket(...params)
        ).subscribe((s) => {
          this.Futures = s.results;
          this.renderPaginatorFutures(s);
        }),
      [TicketTypeEnum.SwapCetip]: () =>
        this.mapTicketData(
          this.ticketService.SwapCETIP.listTicket(...params)
        ).subscribe((s) => {
          this.SwapCetip = s.results;
          this.renderPaginatorSwapCetip(s);
        }),
      [TicketTypeEnum.Margin]: () =>
        this.mapTicketData(
          this.ticketService.Margin.listTicket(...params)
        ).subscribe((s) => {
          this.Margin = s.results;
          this.renderPaginatorMargin(s);
        }),
      [TicketTypeEnum.CurrencyTerm]: () =>
        this.mapTicketData(
          this.ticketService.CurrencyTerm.listTicket(...params)
        ).subscribe((s) => {
          this.CurrencyTerm = s.results;
          this.renderPaginatorCurrencyTerm(s);
        }),
      [TicketTypeEnum.VariableIncome]: () =>
        this.mapTicketData(
          this.ticketService.VariableIncome.listTicket(...params)
        ).subscribe((s) => {
          this.VariableIncome = s.results;
          this.renderPaginatorVariableIncome(s);
        }),
      [TicketTypeEnum.Transfer]: () =>
        this.mapTicketData(
          this.ticketService.Transfer.listTicket(...params)
        ).subscribe((s) => {
          this.Transfer = s.results;
          this.renderPaginatorTransfer(s);
        }),
      [TicketTypeEnum.Loan]: () =>
        this.mapTicketData(
          this.ticketService.Loan.listTicket(...params)
        ).subscribe((s) => {
          this.Loan = s.results;
          this.renderPaginatorLoan(s);
        }),
      [TicketTypeEnum.Exchange]: () =>
        this.mapTicketData(
          this.ticketService.Exchange.listTicket(...params)
        ).subscribe((s) => {
          this.Exchange = s.results;
          this.renderPaginatorExchange(s);
        }),
      [TicketTypeEnum.Expenses]: () =>
        this.mapTicketData(
          this.ticketService.Expenses.listTicket(...params)
        ).subscribe((s) => {
          this.Expenses = s.results;
          this.renderPaginatorExpenses(s);
        }),
      [TicketTypeEnum.Liabilities]: () =>
        this.mapTicketData(
          this.ticketService.Liabilities.listTicket<
            PagedList<LiabilitiesModel>
          >(...params)
        ).subscribe((s) => {
          this.Liabilities = s.results;
          this.renderPaginatorLiabilities(s);
        }),
      [TicketTypeEnum.StructuredOperations]: () =>
        this.mapTicketData(
          this.ticketService.StructuredOperations.listTicket(...params)
        ).subscribe((s) => {
          this.StructuredOperations = s.results;
          this.renderPaginatorStructured(s);
        }),
      [TicketTypeEnum.StructuredOperationOrder]: () =>
        this.mapTicketData(
          this.ticketService.StructuredOperationOrder.listTicket(...params)
        ).subscribe((s) => {
          this.StructuredOrder = s.results;
          this.renderPaginatorStructuredOrder(s);
        }),
    };

    if (ticketType) {
      methods[ticketType]();

      if (!ignoreViewChanges) {
        this.ActiveTicketId = ticketType;
        this.IsTicketTypeFilter = true;
      }

      return;
    }

    Object.keys(methods).forEach((k) => {
      if (this.authService.hasRole(this.TicketRoleMap[k])) {
        methods[k]();
      }
    });

    this.IsTicketTypeFilter = false;
  }

  getParamsFromMonitorFilter() {
    return [
      this.monitorFilter.dateType,
      this.monitorFilter.fromDate,
      this.monitorFilter.untilDate,
      this.monitorFilter.statusId,
      this.monitorFilter.operationTypeId,
      this.monitorFilter.settlementTypeId,
      this.monitorFilter.fundCode,
      this.monitorFilter.fundName,
      this.validator.sanitize(this.monitorFilter.fundCnpj || ""),
      this.monitorFilter.ticketId,
      this.monitorFilter.accountManagerId,
    ];
  }

  loadQuotaPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.quotaCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.quotaPageSize = pageSize;
    } else if (this.quotaPageSize) {
      params.push(this.quotaPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.FundQuota.listTicket<PagedList<FundQuota>>(...params)
    ).subscribe((s) => {
      this.Quotas = s.results;

      this.masterClear(TicketTypeEnum.Quota);

      this.renderPaginatorQuota(s);
    });
  }

  loadCetipPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.cetipCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.cetipPageSize = pageSize;
    } else if (this.cetipPageSize) {
      params.push(this.cetipPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.PrivateFixedIncome.listTicket(...params)
    ).subscribe((s) => {
      this.PrivateFixedIncome = s.results;

      this.masterClear(TicketTypeEnum.CETIP);

      this.renderPaginatorCetip(s);
    });
  }

  loadSelicPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.selicCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.selicPageSize = pageSize;
    } else if (this.selicPageSize) {
      params.push(this.selicPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.PublicFixedIncome.listTicket(...params)
    ).subscribe((s) => {
      this.PublicFixedIncome = s.results;

      this.masterClear(TicketTypeEnum.SELIC);

      this.renderPaginatorSelic(s);
    });
  }

  loadContractedPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.contractedCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.contractedPageSize = pageSize;
    } else if (this.contractedPageSize) {
      params.push(this.contractedPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.Contracted.listTicket(...params)
    ).subscribe((s) => {
      this.Contracted = s.results;

      this.masterClear(TicketTypeEnum.Contracted);

      this.renderPaginatorContracted(s);
    });
  }

  loadFuturesPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.futuresCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.futuresPageSize = pageSize;
    } else if (this.futuresPageSize) {
      params.push(this.futuresPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.Futures.listTicket(...params)
    ).subscribe((s) => {
      this.Futures = s.results;

      this.masterClear(TicketTypeEnum.Futures);

      this.renderPaginatorFutures(s);
    });
  }

  loadSwapCetipPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.swapCetipCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.swapCetipPageSize = pageSize;
    } else if (this.swapCetipPageSize) {
      params.push(this.swapCetipPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.SwapCETIP.listTicket(...params)
    ).subscribe((s) => {
      this.SwapCetip = s.results;

      this.masterClear(TicketTypeEnum.SwapCetip);

      this.renderPaginatorSwapCetip(s);
    });
  }

  loadMarginPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.marginCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.marginPageSize = pageSize;
    } else if (this.marginPageSize) {
      params.push(this.marginPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.Margin.listTicket(...params)
    ).subscribe((s) => {
      this.Margin = s.results;

      this.masterClear(TicketTypeEnum.Margin);

      this.renderPaginatorMargin(s);
    });
  }

  loadCurrencyTermPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.currencyTermCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.currencyTermPageSize = pageSize;
    } else if (this.currencyTermPageSize) {
      params.push(this.currencyTermPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.CurrencyTerm.listTicket(...params)
    ).subscribe((s) => {
      this.CurrencyTerm = s.results;

      this.masterClear(TicketTypeEnum.CurrencyTerm);

      this.renderPaginatorCurrencyTerm(s);
    });
  }

  loadVariableIncomePaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.variableIncomeCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.variableIncomePageSize = pageSize;
    } else if (this.variableIncomePageSize) {
      params.push(this.variableIncomePageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.VariableIncome.listTicket(...params)
    ).subscribe((s) => {
      this.VariableIncome = s.results;

      this.masterClear(TicketTypeEnum.VariableIncome);

      this.renderPaginatorVariableIncome(s);
    });
  }

  loadTransferPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.transferCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.transferPageSize = pageSize;
    } else if (this.transferPageSize) {
      params.push(this.transferPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.Transfer.listTicket(...params)
    ).subscribe((s) => {
      this.Transfer = s.results;

      this.masterClear(TicketTypeEnum.Transfer);

      this.renderPaginatorTransfer(s);
    });
  }

  loadLoanPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.loanCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.loanPageSize = pageSize;
    } else if (this.loanPageSize) {
      params.push(this.loanPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(this.ticketService.Loan.listTicket(...params)).subscribe(
      (s) => {
        this.Loan = s.results;

        this.masterClear(TicketTypeEnum.Loan);

        this.renderPaginatorLoan(s);
      }
    );
  }

  loadExchangePaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.exchangeCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.exchangePageSize = pageSize;
    } else if (this.exchangePageSize) {
      params.push(this.exchangePageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.Exchange.listTicket(...params)
    ).subscribe((s) => {
      this.Exchange = s.results;

      this.masterClear(TicketTypeEnum.Exchange);

      this.renderPaginatorExchange(s);
    });
  }

  loadExpensesPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.expensesCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.expensesPageSize = pageSize;
    } else if (this.expensesPageSize) {
      params.push(this.expensesPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.Expenses.listTicket(...params)
    ).subscribe((s) => {
      this.Expenses = s.results;

      this.masterClear(TicketTypeEnum.Expenses);

      this.renderPaginatorExpenses(s);
    });
  }

  loadLiabilitiesPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.liabilitiesCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.liabilitiesPageSize = pageSize;
    } else if (this.liabilitiesPageSize) {
      params.push(this.liabilitiesPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.Liabilities.listTicket<PagedList<LiabilitiesModel>>(
        ...params
      )
    ).subscribe((s) => {
      this.Liabilities = s.results;

      this.masterClear(TicketTypeEnum.Liabilities);

      this.renderPaginatorLiabilities(s);
    });
  }

  loadStructuredPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.structuredCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.expensesPageSize = pageSize;
    } else if (this.expensesPageSize) {
      params.push(this.expensesPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.StructuredOperations.listTicket(...params)
    ).subscribe((s) => {
      this.StructuredOperations = s.results;

      this.masterClear(TicketTypeEnum.StructuredOperations);

      this.renderPaginatorStructured(s);
    });
  }

  loadStructuredOrderPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.structuredOrderCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.structuredOrderPageSize = pageSize;
    } else if (this.structuredOrderPageSize) {
      params.push(this.structuredOrderPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.mapTicketData(
      this.ticketService.StructuredOperationOrder.listTicket(...params)
    ).subscribe((s) => {
      this.StructuredOrder = s.results;

      this.masterClear(TicketTypeEnum.StructuredOperationOrder);

      this.renderPaginatorStructuredOrder(s);
    });
  }

  mapTicketData(source: Observable<PagedList<any>>) {
    this.loaderService.addLoader();

    return source
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();

          if (err.status === 404) {
            return of([]);
          }
          return throwError(err);
        })
      )
      .pipe(
        map((s: PagedList<any>) => {
          s.results.forEach((t) => {
            if (t.electronicTransfers) {
              t.statusElectronicTransferAvailable =
                t.electronicTransfers.length > 0
                  ? t.electronicTransfers[0].statusId
                  : "";

              t.lastStatusDate =
                t.electronicTransfers.length > 0
                  ? t.electronicTransfers[0].lastStatusDate
                  : "";
            } else {
              t.statusElectronicTransferAvailable = "";
              t.lastStatusDate = "";
            }

            if (t.workflowStartDate) {
              const startDate = DateTime.fromISO(t.workflowStartDate);
              const endDate = DateTime.fromISO(t.workflowEndDate);

              const timestamp = DateTime.local();

              if (t.workflowStartDate && t.workflowEndDate) {
                t.elapsedTime = endDate.diff(startDate, ["hours", "minutes"]);
              } else {
                t.elapsedTime = timestamp.diff(startDate, ["hours", "minutes"]);
              }
            } else {
              t.elapsedTime = null;
            }
            if (t.portfolioDocument != null) {
              t.portfolioDocument = t.portfolioDocument.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                "$1.$2.$3/$4-$5"
              );
            }

            if (t.counterpartDocument != null) {
              t.counterpartDocument = t.counterpartDocument.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                "$1.$2.$3/$4-$5"
              );
            }

            if (t.portfolio != null && t.portfolio.document != null) {
              t.portfolio.document = t.portfolio.document.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                "$1.$2.$3/$4-$5"
              );
            }

            if (t.counterpart != null && t.counterpart.document != null) {
              t.counterpart.document = t.counterpart.document.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                "$1.$2.$3/$4-$5"
              );
            }
          });
          this.hasElectronicTransfer = s.results.some(
            (t) => t.statusId === 11 || t.statusId === 8
          );
          this.loaderService.removeLoader();

          return s;
        })
      );
  }

  filter() {
    this.filterToParams();
    this.populate();
  }

  filterToParams() {
    this.router.navigate(["."], {
      relativeTo: this.route,
      queryParams: {
        dateType: this.monitorFilter.dateType,
        fromDate: this.monitorFilter.fromDate.getTime(),
        untilDate: this.monitorFilter.untilDate.getTime(),
        statusId: this.monitorFilter.statusId,
        settlementTypeId: this.monitorFilter.settlementTypeId,
        operationTypeId: this.monitorFilter.operationTypeId,
        ticketType: this.monitorFilter.ticketType,
        ticketId: this.monitorFilter.ticketId,
        fundCode: this.monitorFilter.fundCode,
        fundName: this.monitorFilter.fundName,
        fundCnpj: this.monitorFilter.fundCnpj,
        accountManangerId: this.monitorFilter.accountManagerId,
      },
    });
  }

  clear() {
    this.monitorFilter = new MonitorFilter();
    this.monitorFilter.dateType = FilterDateType.SettlementDate;

    this.monitorFilter.untilDate = new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      this.today.getDate()
    );
    this.monitorFilter.fromDate = new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      this.today.getDate()
    );

    this.filterToParams();

    this.populate();
  }

  export() {
    this.loaderService.addLoader();
    const method = this.ticketService.export(
      this.monitorFilter.ticketType,
      this.monitorFilter.fromDate,
      this.monitorFilter.untilDate,
      this.monitorFilter.statusId,
      this.monitorFilter.operationTypeId,
      this.monitorFilter.settlementTypeId,
      this.monitorFilter.fundCode,
      this.monitorFilter.fundName,
      this.monitorFilter.fundCnpj,
      this.monitorFilter.ticketId,
      this.monitorFilter.accountManagerId,
      this.monitorFilter.dateType
    );

    return method.subscribe(
      (data: Blob) => {
        const filename = `boletas_${DateTime.local().toFormat(
          "yyyyMMdd"
        )}.xlsx`;
        this.downloadService.downloadFile(data, filename);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open("Não foi possível exportar o arquivo.", "OK");
      }
    );
  }

  periodoError() {
    if (
      this.monitorFilter.untilDate == null ||
      this.monitorFilter.fromDate == null
    ) {
      return true;
    }
    return (
      this.monitorFilter.fromDate.getTime() >
      this.monitorFilter.untilDate.getTime() + 100
    );
  }

  dateTypeFilterChange() {
    this.monitorFilter.statusId = 0;
  }

  statusFilterDisabled() {
    return false; //return this.monitorFilter.dateType == FilterDateType.SettlementDate;
  }

  isAllSelected(ticketType: TicketTypeEnum) {
    const tickets: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () =>
        this.SelectionQuotas.selected.length === this.Quotas.length,
      [TicketTypeEnum.CETIP]: () =>
        this.SelectionPrivateFixedIncome.selected.length ===
        this.PrivateFixedIncome.length,
      [TicketTypeEnum.SELIC]: () =>
        this.SelectionPublicFixedIncome.selected.length ===
        this.PublicFixedIncome.length,
      [TicketTypeEnum.Contracted]: () =>
        this.SelectionContracted.selected.length === this.Contracted.length,
      [TicketTypeEnum.Futures]: () =>
        this.SelectionFutures.selected.length === this.Futures.length,
      [TicketTypeEnum.SwapCetip]: () =>
        this.SelectionSwapCetip.selected.length === this.SwapCetip.length,
      [TicketTypeEnum.Margin]: () =>
        this.SelectionMargin.selected.length === this.Margin.length,
      [TicketTypeEnum.CurrencyTerm]: () =>
        this.SelectionCurrencyTerm.selected.length === this.CurrencyTerm.length,
      [TicketTypeEnum.VariableIncome]: () =>
        this.SelectionVariableIncome.selected.length ===
        this.VariableIncome.length,
      [TicketTypeEnum.Transfer]: () =>
        this.SelectionTransfer.selected.length === this.Transfer.length,
      [TicketTypeEnum.Exchange]: () =>
        this.SelectionExchange.selected.length === this.Exchange.length,
      [TicketTypeEnum.Loan]: () =>
        this.SelectionLoan.selected.length === this.Loan.length,
      [TicketTypeEnum.Expenses]: () =>
        this.SelectionExpenses.selected.length === this.Expenses.length,
      [TicketTypeEnum.Liabilities]: () =>
        this.SelectionLiabilities.selected.length === this.Liabilities.length,
      [TicketTypeEnum.StructuredOperations]: () =>
        this.SelectionStructured.selected.length ===
        this.StructuredOperations.length,
      [TicketTypeEnum.StructuredOperationOrder]: () =>
        this.SelectionStructuredOrder.selected.length ===
        this.StructuredOrder.length,
    };

    return tickets[ticketType]();
  }

  masterToggle(ticketType: TicketTypeEnum) {
    const tickets: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [this.SelectionQuotas, this.Quotas],
      [TicketTypeEnum.CETIP]: () => [
        this.SelectionPrivateFixedIncome,
        this.PrivateFixedIncome,
      ],
      [TicketTypeEnum.SELIC]: () => [
        this.SelectionPublicFixedIncome,
        this.PublicFixedIncome,
      ],
      [TicketTypeEnum.Contracted]: () => [
        this.SelectionContracted,
        this.Contracted,
      ],
      [TicketTypeEnum.Futures]: () => [this.SelectionFutures, this.Futures],
      [TicketTypeEnum.SwapCetip]: () => [
        this.SelectionSwapCetip,
        this.SwapCetip,
      ],
      [TicketTypeEnum.Margin]: () => [this.SelectionMargin, this.Margin],
      [TicketTypeEnum.CurrencyTerm]: () => [
        this.SelectionCurrencyTerm,
        this.CurrencyTerm,
      ],
      [TicketTypeEnum.VariableIncome]: () => [
        this.SelectionVariableIncome,
        this.VariableIncome,
      ],
      [TicketTypeEnum.Exchange]: () => [this.SelectionExchange, this.Exchange],
      [TicketTypeEnum.Loan]: () => [this.SelectionLoan, this.Loan],
      [TicketTypeEnum.Expenses]: () => [this.SelectionExpenses, this.Expenses],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        this.Liabilities,
      ],
      [TicketTypeEnum.StructuredOperations]: () => [
        this.SelectionStructured,
        this.StructuredOperations,
      ],
      [TicketTypeEnum.StructuredOperationOrder]: () => [
        this.SelectionStructuredOrder,
        this.StructuredOrder,
      ],
    };

    const data = tickets[ticketType]();

    this.isAllSelected(ticketType)
      ? data[0].clear()
      : data[1].forEach((row) => {
          if (this.canForward(ticketType, row)) {
            data[0].select(row);
          }
        });
  }

  masterClear(ticketType: TicketTypeEnum) {
    const tickets: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => this.SelectionQuotas,
      [TicketTypeEnum.CETIP]: () => this.SelectionPrivateFixedIncome,
      [TicketTypeEnum.SELIC]: () => this.SelectionPublicFixedIncome,
      [TicketTypeEnum.Contracted]: () => this.SelectionContracted,
      [TicketTypeEnum.Futures]: () => this.SelectionFutures,
      [TicketTypeEnum.SwapCetip]: () => this.SelectionSwapCetip,
      [TicketTypeEnum.Margin]: () => this.SelectionMargin,
      [TicketTypeEnum.CurrencyTerm]: () => this.SelectionCurrencyTerm,
      [TicketTypeEnum.VariableIncome]: () => this.SelectionVariableIncome,
      [TicketTypeEnum.Transfer]: () => this.SelectionTransfer,
      [TicketTypeEnum.Exchange]: () => this.SelectionExchange,
      [TicketTypeEnum.Loan]: () => this.SelectionLoan,
      [TicketTypeEnum.Expenses]: () => this.SelectionExpenses,
      [TicketTypeEnum.Liabilities]: () => this.SelectionLiabilities,
      [TicketTypeEnum.StructuredOperations]: () => this.SelectionStructured,
      [TicketTypeEnum.StructuredOperationOrder]: () =>
        this.SelectionStructuredOrder,
    };

    const data = tickets[ticketType]();

    (data as SelectionModel<any>).clear();
  }

  hasForwardRole(ticketType: TicketTypeEnum) {
    return this.authService.hasRole(this.TicketRoleCreateMap[ticketType]);
  }

  hasApproveRole(ticketType: TicketTypeEnum): boolean {
    const tickets: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [this.SelectionQuotas, this.Quotas],
      [TicketTypeEnum.CETIP]: () => [
        this.SelectionPrivateFixedIncome,
        this.PrivateFixedIncome,
      ],
      [TicketTypeEnum.SELIC]: () => [
        this.SelectionPublicFixedIncome,
        this.PublicFixedIncome,
      ],
      [TicketTypeEnum.Contracted]: () => [
        this.SelectionContracted,
        this.Contracted,
      ],
      [TicketTypeEnum.Futures]: () => [this.SelectionFutures, this.Futures],
      [TicketTypeEnum.SwapCetip]: () => [
        this.SelectionSwapCetip,
        this.SwapCetip,
      ],
      [TicketTypeEnum.Margin]: () => [this.SelectionMargin, this.Margin],
      [TicketTypeEnum.CurrencyTerm]: () => [
        this.SelectionCurrencyTerm,
        this.CurrencyTerm,
      ],
      [TicketTypeEnum.VariableIncome]: () => [
        this.SelectionVariableIncome,
        this.VariableIncome,
      ],
      [TicketTypeEnum.Transfer]: () => [this.SelectionTransfer, this.Transfer],
      [TicketTypeEnum.Exchange]: () => [this.SelectionExchange, this.Exchange],
      [TicketTypeEnum.Loan]: () => [this.SelectionLoan, this.Loan],
      [TicketTypeEnum.Expenses]: () => [this.SelectionExpenses, this.Expenses],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        this.Liabilities,
      ],
      [TicketTypeEnum.StructuredOperations]: () => [
        this.SelectionStructured,
        this.StructuredOperations,
      ],
      [TicketTypeEnum.StructuredOperationOrder]: () => [
        this.SelectionStructuredOrder,
        this.StructuredOrder,
      ],
    };

    const data = tickets[ticketType]();

    for (const row of data[1]) {
      if (this.canApprove(row)) {
        return true;
      }
    }

    return false;
  }

  canForward(ticketType: TicketTypeEnum, row: Ticket) {
    return (
      !row.statusId &&
      !row.statusDescription &&
      this.authService.hasRole(this.TicketRoleCreateMap[ticketType])
    );
  }

  canApprove(row: any) {
    return (
      row.statusId &&
      row.statusRequiredRoles &&
      this.authService.hasRoles(row.statusRequiredRoles) &&
      (row.statusDescription != "Pendente de Aprovação pela ADM"
        ? true
        : !row.isManualSettlementDate) &&
      row.statusDescription != "Aguardando Aprovação pela Controladoria" &&
      row.statusDescription != "Em Análise" &&
      row.statusDescription != "Em Pré-Análise"
    );
  }

  /**
   * @description Check if can check status of Matera Tranfer
   * @returns true if workflow status is on transfer liquidation
   */
  canCheckStatusTransfer(ticketType: TicketTypeEnum): boolean {
    if (ticketType === TicketTypeEnum.Quota) {
      return (
        this.hasElectronicTransfer &&
        this.authService.hasRole(Roles.ApproveActiveSettlementMiddle)
      );
    } else {
      return (
        this.hasElectronicTransfer &&
        this.authService.hasRole(Roles.ApproveActiveSettlement)
      );
    }
  }

  canCheck(ticketType: TicketTypeEnum, row: Ticket) {
    return this.canForward(ticketType, row) || this.canApprove(row);
  }

  forwardMany(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id) => this.ticketService.FundQuota.forwardTicket(id),
      ],
      [TicketTypeEnum.CETIP]: () => [
        this.SelectionPrivateFixedIncome,
        (id) => this.ticketService.PrivateFixedIncome.forwardTicket(id),
      ],
      [TicketTypeEnum.SELIC]: () => [
        this.SelectionPublicFixedIncome,
        (id) => this.ticketService.PublicFixedIncome.forwardTicket(id),
      ],
      [TicketTypeEnum.Contracted]: () => [
        this.SelectionContracted,
        (id) => this.ticketService.Contracted.forwardTicket(id),
      ],
      [TicketTypeEnum.Futures]: () => [
        this.SelectionFutures,
        (id) => this.ticketService.Futures.forwardTicket(id),
      ],
      [TicketTypeEnum.SwapCetip]: () => [
        this.SelectionSwapCetip,
        (id) => this.ticketService.SwapCETIP.forwardTicket(id),
      ],
      [TicketTypeEnum.Margin]: () => [
        this.SelectionMargin,
        (id) => this.ticketService.Margin.forwardTicket(id),
      ],
      [TicketTypeEnum.CurrencyTerm]: () => [
        this.SelectionCurrencyTerm,
        (id) => this.ticketService.CurrencyTerm.forwardTicket(id),
      ],
      [TicketTypeEnum.VariableIncome]: () => [
        this.SelectionVariableIncome,
        (id) => this.ticketService.VariableIncome.forwardTicket(id),
      ],
      [TicketTypeEnum.Transfer]: () => [
        this.SelectionTransfer,
        (id) => this.ticketService.Transfer.forwardTicket(id),
      ],
      [TicketTypeEnum.Loan]: () => [
        this.SelectionLoan,
        (id) => this.ticketService.Loan.forwardTicket(id),
      ],
      [TicketTypeEnum.Exchange]: () => [
        this.SelectionExchange,
        (id) => this.ticketService.Exchange.forwardTicket(id),
      ],
      [TicketTypeEnum.Expenses]: () => [
        this.SelectionExpenses,
        (id) => this.ticketService.Expenses.forwardTicket(id),
      ],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        (id) => this.ticketService.Liabilities.forwardTicket(id),
      ],
      [TicketTypeEnum.StructuredOperations]: () => [
        this.SelectionStructured,
        (id) => this.ticketService.StructuredOperations.forwardTicket(id),
      ],
      [TicketTypeEnum.StructuredOperationOrder]: () => [
        this.SelectionStructuredOrder,
        (id) => this.ticketService.StructuredOperationOrder.forwardTicket(id),
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    const selectedTickets = data[0].selected;
    const checkPermissionList: TicketCutoffTicketPermission[] = [];

    const enabledToForward = [];

    for (const item of selectedTickets) {
      const itemToCheck = new TicketCutoffTicketPermission();
      itemToCheck.ticketCutoffTypeId = item.ticketCutoffTypeId;
      itemToCheck.ticketId = item.id;
      itemToCheck.accountManagerId = item.accountManagerId;

      if (item.portfolioFundId != null) {
        itemToCheck.fundId = item.portfolioFundId;
      } else if (item.portfolio.fundId != null) {
        itemToCheck.fundId = item.portfolio.fundId;
      }

      checkPermissionList.push(itemToCheck);
    }

    this.cutoffService
      .getMultiplePermisssion(checkPermissionList)
      .subscribe((res) => {
        for (const item of res) {
          const itemToForward = selectedTickets.find(
            (x) => x.id === item.ticketId && item.isAllowed
          );

          if (itemToForward) {
            enabledToForward.push(itemToForward);
          }
        }

        if (enabledToForward.length === 0) {
          this.dialogService.inform(
            "Encaminhar boletas",
            `Não é possível encaminhar a boleta após horário limite `
          );
          return;
        }
        let mensageCutoff = `Deseja encaminhar ${selectedTickets.length} boleta(s)?`;
        if (selectedTickets.length !== enabledToForward.length) {
          mensageCutoff = `Das ${selectedTickets.length} boletas selecionadas, \
        ${
          selectedTickets.length - enabledToForward.length
        } boletas não podem ser encaminhadas \
        devido ao horário de cutoff.<br/><br/> \
        Deseja encaminhar as ${enabledToForward.length} boletas restantes?`;
        }
        this.dialogService
          .confirm(
            "Encaminhar boleta(s)",
            mensageCutoff,
            null,
            null,
            DialogSize.Medium
          )
          .subscribe((result) => {
            if (!result) {
              return;
            }
            let check = Promise.resolve(true);

            if (ticketType === TicketTypeEnum.Quota) {
              const mensagem =
                "É necessário enviar a ordem desta operação para a Contraparte (Fundo Investido), \
          com a confirmação que será convertida, para que seja processada corretamente.<br /><br />\
          O não atendimento do procedimento acima poderá acarretar em cancelamento da operação e/ou atraso na \
          divulgação da cota do Fundo.";

              check = this.dialogService
                .confirm(
                  "Alerta",
                  mensagem,
                  "OK",
                  "Cancelar",
                  DialogSize.Medium
                )
                .toPromise();
            }

            for (let i = 0; i < enabledToForward.length; i++) {
              const item = enabledToForward[i] as Ticket;

              const operationDate = DateTime.fromJSDate(
                new Date(item.operationDate.toString())
              );

              if (operationDate.day < DateTime.local().day) {
                check = this.dialogService
                  .confirm(
                    "Boleta(s) Retroativa(s)",
                    "Uma ou mais boletas selecionadas possuem data de operação retroativa e serão atualizadas para a data de hoje.",
                    "OK",
                    "Cancelar"
                  )
                  .toPromise();

                break;
              }
            }

            check.then((ok) => {
              if (!ok) {
                return;
              }

              const promises: Promise<any>[] = [];
              (enabledToForward as Ticket[]).forEach((b) => {
                promises.push((data[1](b.id) as Observable<any>).toPromise());
              });
              Promise.all(promises).then(() => {
                this.snackBarService.open("Boleta(s) encaminhada(s).", "OK", {
                  verticalPosition: "top",
                  horizontalPosition: "right",
                });
                this.load(ticketType, true);
              });
              this.masterClear(ticketType);
            });
          });
      });
  }

  approveMany(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.CETIP]: () => [
        this.SelectionPrivateFixedIncome,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.SELIC]: () => [
        this.SelectionPublicFixedIncome,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Contracted]: () => [
        this.SelectionContracted,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Futures]: () => [
        this.SelectionFutures,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.SwapCetip]: () => [
        this.SelectionSwapCetip,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Margin]: () => [
        this.SelectionMargin,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.CurrencyTerm]: () => [
        this.SelectionCurrencyTerm,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.VariableIncome]: () => [
        this.SelectionVariableIncome,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Transfer]: () => [
        this.SelectionTransfer,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Loan]: () => [
        this.SelectionLoan,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Exchange]: () => [
        this.SelectionExchange,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Expenses]: () => [
        this.SelectionExpenses,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.StructuredOperations]: () => [
        this.SelectionStructured,
        (id: number, approvalGroupIds: any) => {
          var modelGroups = approvalGroupIds;
          var auth = this.authService.getAuth();
          var groupRole = auth.groupRoles.find(function (groupRole) {
            return modelGroups.some((x) => x == groupRole.groupId);
          });
          return this.ticketService.approve(id, "", groupRole.groupId);
        },
      ],
      [TicketTypeEnum.StructuredOperationOrder]: () => [
        this.SelectionStructuredOrder,
        (id: number) => this.ticketService.approve(id),
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    this.dialogService
      .confirm(
        "Aprovar boleta(s)",
        `Deseja aprovar ${data[0].selected.length} boleta(s)?`
      )
      .subscribe((userWantsToApproveTicket: boolean) => {
        if (userWantsToApproveTicket) {
          const promises: Promise<any>[] = [];
          (data[0].selected as Ticket[]).forEach((ticket) => {
            promises.push(
              (
                data[1](ticket.id, ticket.approvalGroupIds) as Observable<any>
              ).toPromise()
            );
          });
          Promise.all(promises).then(() => {
            this.snackBarService.open("Boleta(s) aprovadas(s).", "OK");
            this.load(ticketType, true);
          });
          this.masterClear(ticketType);
        }
      });
  }

  rejectMany(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.CETIP]: () => [
        this.SelectionPrivateFixedIncome,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.SELIC]: () => [
        this.SelectionPublicFixedIncome,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Contracted]: () => [
        this.SelectionContracted,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Futures]: () => [
        this.SelectionFutures,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.SwapCetip]: () => [
        this.SelectionSwapCetip,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Margin]: () => [
        this.SelectionMargin,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.CurrencyTerm]: () => [
        this.SelectionCurrencyTerm,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Transfer]: () => [
        this.SelectionTransfer,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Loan]: () => [
        this.SelectionLoan,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Exchange]: () => [
        this.SelectionExchange,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Expenses]: () => [
        this.SelectionExpenses,
        (id: number) => this.ticketService.reject(id, null),
      ],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        (id: number) => this.ticketService.reject(id, null),
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    this.dialogService
      .confirm(
        "Reprovar boleta(s)",
        `Deseja reprovar ${data[0].selected.length} boleta(s)?`
      )
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          const promises: Promise<any>[] = [];
          (data[0].selected as Ticket[]).forEach((ticket) => {
            promises.push(
              (data[1](ticket.id, "") as Observable<any>).toPromise()
            );
          });
          Promise.all(promises).then(() => {
            this.snackBarService.open("Boleta(s) reprovadas(s).", "OK");
            this.load(ticketType, true);
          });
          this.masterClear(ticketType);
        }
      });
  }

  revise(id, params?) {
    return of({ id, params, operation: "revise" });
  }

  getById(id) {
    return of({ id, operation: "getById" });
  }

  async approveManyLiquidation(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id: number, canSendTransfer: boolean) => {
          return this.ticketService.FundQuota.approveWithEletronicTransfer(
            id,
            canSendTransfer
          );
        },
      ],
      [TicketTypeEnum.Margin]: () => [
        this.SelectionMargin,
        (id: number, canSendTransfer: boolean) => {
          return this.ticketService.Margin.approveWithEletronicTransfer(
            id,
            canSendTransfer
          );
        },
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    this.dialogService
      .confirm(
        "Aprovar boleta(s)",
        `Deseja aprovar ${data[0].selected.length} boleta(s)?`
      )
      .subscribe(async (userWantsToApproveTicket: boolean) => {
        if (userWantsToApproveTicket) {
          const approvePromises: Promise<any>[] = [];

          (data[0].selected as Ticket[]).forEach((ticket) => {
            const canSendTransferForLiquidation =
              this.canSendTransferForLiquidation(ticketType, ticket.statusId);
            approvePromises.push(
              (
                data[1](
                  ticket.id,
                  canSendTransferForLiquidation
                ) as Observable<any>
              ).toPromise()
            );
          });

          await Promise.all(approvePromises).then(() => {
            this.snackBarService.open("Boleta(s) aprovadas(s).", "OK");
            this.load(ticketType, true);
          });

          this.masterClear(ticketType);
        }
      });
  }

  /**
   * @description Transfer TED to Matera API
   */
  makeEletronicTransfer(ticketType: TicketTypeEnum, ticketId: number) {
    if (ticketType === TicketTypeEnum.Quota) {
      return this.eletronicTransferQuota(ticketId);
    } else if (ticketType === TicketTypeEnum.Margin) {
      return this.eletronicTransferMargin(ticketId);
    }
  }

  private eletronicTransferQuota(ticKetId: number) {
    return this.ticketService.FundQuota.getEletronicTransferQuotaTicket(
      ticKetId
    );
  }

  private eletronicTransferMargin(ticKetId: number) {
    return this.ticketService.Margin.getEletronicTransferMarginTicket(ticKetId);
  }

  canSendTransferForLiquidation(
    ticketType: TicketTypeEnum,
    statusId: number
  ): boolean {
    if (ticketType === TicketTypeEnum.Quota) {
      return this.canSendTransferForLiquidationQuota(statusId);
    } else if (ticketType === TicketTypeEnum.Margin) {
      return this.canSendTransferForLiquidationMargin(statusId);
    }
  }

  /**
   * @description Check if can send tranfer for liquidation
   * @returns true if workflow status is awaiting Shipping / Receiving of Matera Transfer
   */
  private canSendTransferForLiquidationQuota(statusId: number): boolean {
    return (
      statusId === 10 &&
      this.authService.hasRole(Roles.ApprovePendingSettlementMiddle)
    );
  }

  /**
   * @description Check if can send tranfer for liquidation
   * @returns true if workflow status is awaiting Shipping / Receiving of Matera Transfer
   */
  private canSendTransferForLiquidationMargin(statusId: number): boolean {
    return (
      statusId === 7 &&
      this.authService.hasRole(Roles.ApprovePendingSettlementCustody)
    );
  }

  checkStatusMany(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id: number) =>
          this.ticketService.getEletronicTransferSituationTicket(id),
      ],
      [TicketTypeEnum.Margin]: () => [
        this.SelectionMargin,
        (id: number) =>
          this.ticketService.getEletronicTransferSituationTicket(id),
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    this.dialogService
      .confirm(
        "Consultar boleta(s)",
        `Deseja consultar status ${data[0].selected.length} boleta(s)?`
      )
      .subscribe((result) => {
        if (result) {
          const promises: Promise<any>[] = [];
          (data[0].selected as Ticket[]).forEach((b) => {
            promises.push((data[1](b.id) as Observable<any>).toPromise());
          });
          Promise.all(promises)
            .then((status) => {
              this.snackBarService.open(
                "Boleta(s) status consultado(s).",
                "OK"
              );
              this.load(ticketType, true);
            })
            .catch((exception) => {
              console.error("failed:", exception.error.message);
            });
          this.masterClear(ticketType);
        }
      });
  }

  eletronicTransferStatementDialog(ticket: FundQuota | Margin) {
    this.dialogService.eletronicTransferStatement(
      ticket.portfolioAccount,
      ticket.operationDate
    );
  }

  eletronicTransferReleasesDialog(ticket: FundQuota | Margin) {
    this.dialogService.eletronicTransferReleases(
      ticket.portfolioAccount,
      ticket.operationDate
    );
  }

  transferStatusDialog(ticket: any) {
    this.dialogService.transferStatus(ticket.id);
  }

  showEletronicStatementModal(ticket: any) {
    if (
      !this.isAccountManager() &&
      (ticket.operationTypeId === OperationTypeEnum.Application ||
        ticket.operationTypeId === OperationTypeEnum.Deposit) &&
      ticket.statusElectronicTransferAvailable === EletronicTransferStatus.SENT
    ) {
      return true;
    }
    return false;
  }

  showEletronicReleasesModal(ticket: any) {
    if (
      !this.isAccountManager() &&
      (((ticket.operationTypeId === OperationTypeQuota.Redemption ||
        ticket.operationTypeId === OperationTypeQuota.FullRedemption) &&
        ticket.statusId === WorkflowStatus.InMiddleSettlement) || // && ticket.ticketType === TicketTypeEnum.Quota
        (ticket.operationTypeId === OperationTypeEnum.Withdrawal &&
          ticket.marketTypeId === MarketType.Cash &&
          ticket.statusId === WorkflowStatus.InDetainerSettlement)) && // && ticket.ticketType === TicketTypeEnum.Margin
      (ticket.statusElectronicTransferAvailable ===
        EletronicTransferStatus.SENT ||
        ticket.electronicTransfers.length === 0)
    ) {
      return true;
    }
    return false;
  }

  possibleWithoutBalance(ticket: any) {
    if (ticket.electronicTransfers.length > 0) {
      const creationDate = DateTime.fromISO(
        ticket.electronicTransfers[0].creationDate
      );
      const utcTime = DateTime.utc();

      const materaElapsedTime = utcTime.diff(creationDate, "minutes");

      if (
        this.electronicTransferTimeLimit.electronicTransferTimeLimit <
        materaElapsedTime.minutes
      ) {
        return true;
      }
    }
    return false;
  }

  setActiveTicket(id: number) {
    const url = this.router.createUrlTree([{ ticketId: id }], {
      relativeTo: this.route,
    });
    this.location.go(url.toString());
  }

  openTicket(ticket: string, id: number) {
    this.router.navigate([ticket, id]);
  }

  canDisplay(ticketType: TicketTypeEnum) {
    return (
      this.authService.hasRole(this.TicketRoleMap[ticketType]) &&
      (!this.IsTicketTypeFilter ||
        (this.IsTicketTypeFilter && this.ActiveTicketId === ticketType))
    );
  }

  isAccountManager() {
    return this.authService.authToken.isAccountManager;
  }

  onAccManagerSelected(item: any) {
    this.monitorFilter.accountManagerId = item.id;
  }

  exibeNomeAccountManager(item?: any): string | undefined {
    return item ? item.document + " " + item.name : undefined;
  }

  private _searchAccountManager(search: string): AccountManager[] {
    const searchTerm = search?.toLowerCase();

    return this.AccountManagers.filter((filtered) =>
      filtered.name.toLowerCase().includes(searchTerm)
    );
  }

  resetPaginators() {
    const listedPagesDefault: any[] = [];
    listedPagesDefault.push(1);

    this.quotaTotalPages =
      this.cetipTotalPages =
      this.contractedTotalPages =
      this.currencyTermTotalPages =
      this.futuresTotalPages =
      this.marginTotalPages =
      this.selicTotalPages =
      this.swapCetipTotalPages =
      this.variableIncomeTotalPages =
      this.transferTotalPages =
      this.loanTotalPages =
      this.exchangeTotalPages =
        1;

    this.quotaCurrentPage =
      this.cetipCurrentPage =
      this.contractedCurrentPage =
      this.currencyTermCurrentPage =
      this.futuresCurrentPage =
      this.marginCurrentPage =
      this.selicCurrentPage =
      this.swapCetipCurrentPage =
      this.variableIncomeCurrentPage =
      this.transferCurrentPage =
      this.loanCurrentPage =
      this.exchangeCurrentPage =
        1;

    // tslint:disable-next-line:max-line-length
    this.quotaFirstItemOnPage =
      this.cetipFirstItemOnPage =
      this.contractedFirstItemOnPage =
      this.currencyTermFirstItemOnPage =
      this.futuresFirstItemOnPage =
      this.marginFirstItemOnPage =
      this.selicFirstItemOnPage =
      this.swapCetipFirstItemOnPage =
      this.variableIncomeFirstItemOnPage =
      this.transferFirstItemOnPage =
      this.loanFirstItemOnPage =
      this.exchangeFirstItemOnPage =
        0;

    this.quotaListedPages =
      this.cetipListedPages =
      this.contractedListedPages =
      this.currencyTermListedPages =
      this.futuresListedPages =
      this.marginListedPages =
      this.selicListedPages =
      this.swapCetipListedPages =
      this.variableIncomeListedPages =
      this.transferListedPages =
      this.loanListedPages =
      this.exchangeListedPages =
        listedPagesDefault;
  }

  // #region renderPaginatorBoleta()

  renderPaginatorQuota(result: PagedList<any>) {
    this.quotaTotalItems = result.rowCount;
    this.quotaTotalPages = result.pageCount;
    this.quotaFirstItemOnPage = result.firstRowOnPage;
    this.quotaLastItemOnPage = result.lastRowOnPage;

    this.quotaCurrentPage = result.currentPage;

    this.quotaListedPages = [];

    let startPage = this.quotaCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.quotaCurrentPage + 2;
    while (maxPage > this.quotaTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.quotaListedPages.push(i);
    }

    if (!result.results.length) {
      this.quotaTotalPages = 1;
      this.quotaCurrentPage = 1;
      this.quotaFirstItemOnPage = 0;

      this.quotaListedPages = [];
      this.quotaListedPages.push(1);
    }
  }

  renderPaginatorCetip(result: PagedList<any>) {
    this.cetipTotalItems = result.rowCount;
    this.cetipTotalPages = result.pageCount;
    this.cetipFirstItemOnPage = result.firstRowOnPage;
    this.cetipLastItemOnPage = result.lastRowOnPage;

    this.cetipCurrentPage = result.currentPage;

    this.cetipListedPages = [];

    let startPage = this.cetipCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.cetipCurrentPage + 2;
    while (maxPage > this.cetipTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.cetipListedPages.push(i);
    }

    if (!result.results.length) {
      this.cetipTotalPages = 1;
      this.cetipCurrentPage = 1;
      this.cetipFirstItemOnPage = 0;

      this.cetipListedPages = [];
      this.cetipListedPages.push(1);
    }
  }

  renderPaginatorSelic(result: PagedList<any>) {
    this.selicTotalItems = result.rowCount;
    this.selicTotalPages = result.pageCount;
    this.selicFirstItemOnPage = result.firstRowOnPage;
    this.selicLastItemOnPage = result.lastRowOnPage;

    this.selicCurrentPage = result.currentPage;

    this.selicListedPages = [];

    let startPage = this.selicCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.selicCurrentPage + 2;
    while (maxPage > this.selicTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.selicListedPages.push(i);
    }

    if (!result.results.length) {
      this.selicTotalPages = 1;
      this.selicCurrentPage = 1;
      this.selicFirstItemOnPage = 0;

      this.selicListedPages = [];
      this.selicListedPages.push(1);
    }
  }

  renderPaginatorContracted(result: PagedList<any>) {
    this.contractedTotalItems = result.rowCount;
    this.contractedTotalPages = result.pageCount;
    this.contractedFirstItemOnPage = result.firstRowOnPage;
    this.contractedLastItemOnPage = result.lastRowOnPage;

    this.contractedCurrentPage = result.currentPage;

    this.contractedListedPages = [];

    let startPage = this.contractedCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.contractedCurrentPage + 2;
    while (maxPage > this.contractedTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.contractedListedPages.push(i);
    }

    if (!result.results.length) {
      this.contractedTotalPages = 1;
      this.contractedCurrentPage = 1;
      this.contractedFirstItemOnPage = 0;

      this.contractedListedPages = [];
      this.contractedListedPages.push(1);
    }
  }

  renderPaginatorFutures(result: PagedList<any>) {
    this.futuresTotalItems = result.rowCount;
    this.futuresTotalPages = result.pageCount;
    this.futuresFirstItemOnPage = result.firstRowOnPage;
    this.futuresLastItemOnPage = result.lastRowOnPage;

    this.futuresCurrentPage = result.currentPage;

    this.futuresListedPages = [];

    let startPage = this.futuresCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.futuresCurrentPage + 2;
    while (maxPage > this.futuresTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.futuresListedPages.push(i);
    }

    if (!result.results.length) {
      this.futuresTotalPages = 1;
      this.futuresCurrentPage = 1;
      this.futuresFirstItemOnPage = 0;

      this.futuresListedPages = [];
      this.futuresListedPages.push(1);
    }
  }

  renderPaginatorSwapCetip(result: PagedList<any>) {
    this.swapCetipTotalItems = result.rowCount;
    this.swapCetipTotalPages = result.pageCount;
    this.swapCetipFirstItemOnPage = result.firstRowOnPage;
    this.swapCetipLastItemOnPage = result.lastRowOnPage;

    this.swapCetipCurrentPage = result.currentPage;

    this.swapCetipListedPages = [];

    let startPage = this.swapCetipCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.swapCetipCurrentPage + 2;
    while (maxPage > this.swapCetipTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.swapCetipListedPages.push(i);
    }

    if (!result.results.length) {
      this.swapCetipTotalPages = 1;
      this.swapCetipCurrentPage = 1;
      this.swapCetipFirstItemOnPage = 0;

      this.swapCetipListedPages = [];
      this.swapCetipListedPages.push(1);
    }
  }

  renderPaginatorMargin(result: PagedList<any>) {
    this.marginTotalItems = result.rowCount;
    this.marginTotalPages = result.pageCount;
    this.marginFirstItemOnPage = result.firstRowOnPage;
    this.marginLastItemOnPage = result.lastRowOnPage;

    this.marginCurrentPage = result.currentPage;

    this.marginListedPages = [];

    let startPage = this.marginCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.marginCurrentPage + 2;
    while (maxPage > this.marginTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.marginListedPages.push(i);
    }

    if (!result.results.length) {
      this.marginTotalPages = 1;
      this.marginCurrentPage = 1;
      this.marginFirstItemOnPage = 0;

      this.marginListedPages = [];
      this.marginListedPages.push(1);
    }
  }

  renderPaginatorCurrencyTerm(result: PagedList<any>) {
    this.currencyTermTotalItems = result.rowCount;
    this.currencyTermTotalPages = result.pageCount;
    this.currencyTermFirstItemOnPage = result.firstRowOnPage;
    this.currencyTermLastItemOnPage = result.lastRowOnPage;

    this.currencyTermCurrentPage = result.currentPage;

    this.currencyTermListedPages = [];

    let startPage = this.currencyTermCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.currencyTermCurrentPage + 2;
    while (maxPage > this.currencyTermTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.currencyTermListedPages.push(i);
    }

    if (!result.results.length) {
      this.currencyTermTotalPages = 1;
      this.currencyTermCurrentPage = 1;
      this.currencyTermFirstItemOnPage = 0;

      this.currencyTermListedPages = [];
      this.currencyTermListedPages.push(1);
    }
  }

  renderPaginatorVariableIncome(result: PagedList<any>) {
    this.variableIncomeTotalItems = result.rowCount;
    this.variableIncomeTotalPages = result.pageCount;
    this.variableIncomeFirstItemOnPage = result.firstRowOnPage;
    this.variableIncomeLastItemOnPage = result.lastRowOnPage;

    this.variableIncomeCurrentPage = result.currentPage;

    this.variableIncomeListedPages = [];

    let startPage = this.variableIncomeCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.variableIncomeCurrentPage + 2;
    while (maxPage > this.variableIncomeTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.variableIncomeListedPages.push(i);
    }

    if (!result.results.length) {
      this.variableIncomeTotalPages = 1;
      this.variableIncomeCurrentPage = 1;
      this.variableIncomeFirstItemOnPage = 0;

      this.variableIncomeListedPages = [];
      this.variableIncomeListedPages.push(1);
    }
  }

  renderPaginatorTransfer(result: PagedList<any>) {
    this.transferTotalItems = result.rowCount;
    this.transferTotalPages = result.pageCount;
    this.transferFirstItemOnPage = result.firstRowOnPage;
    this.transferLastItemOnPage = result.lastRowOnPage;

    this.transferCurrentPage = result.currentPage;

    this.transferListedPages = [];

    let startPage = this.transferCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.transferCurrentPage + 2;
    while (maxPage > this.transferTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.transferListedPages.push(i);
    }

    if (!result.results.length) {
      this.transferTotalPages = 1;
      this.transferCurrentPage = 1;
      this.transferFirstItemOnPage = 0;

      this.transferListedPages = [];
      this.transferListedPages.push(1);
    }
  }

  renderPaginatorLoan(result: PagedList<any>) {
    this.loanTotalItems = result.rowCount;
    this.loanTotalPages = result.pageCount;
    this.loanFirstItemOnPage = result.firstRowOnPage;
    this.loanLastItemOnPage = result.lastRowOnPage;

    this.loanCurrentPage = result.currentPage;

    this.loanListedPages = [];

    let startPage = this.loanCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.loanCurrentPage + 2;
    while (maxPage > this.loanTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.loanListedPages.push(i);
    }

    if (!result.results.length) {
      this.loanTotalPages = 1;
      this.loanCurrentPage = 1;
      this.loanFirstItemOnPage = 0;

      this.loanListedPages = [];
      this.loanListedPages.push(1);
    }
  }

  renderPaginatorExchange(result: PagedList<any>) {
    this.exchangeTotalItems = result.rowCount;
    this.exchangeTotalPages = result.pageCount;
    this.exchangeFirstItemOnPage = result.firstRowOnPage;
    this.exchangeLastItemOnPage = result.lastRowOnPage;

    this.exchangeCurrentPage = result.currentPage;

    this.exchangeListedPages = [];

    let startPage = this.exchangeCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.exchangeCurrentPage + 2;
    while (maxPage > this.exchangeTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.exchangeListedPages.push(i);
    }

    if (!result.results.length) {
      this.exchangeTotalPages = 1;
      this.exchangeCurrentPage = 1;
      this.exchangeFirstItemOnPage = 0;

      this.exchangeListedPages = [];
      this.exchangeListedPages.push(1);
    }
  }

  renderPaginatorExpenses(result: PagedList<any>) {
    this.expensesTotalItems = result.rowCount;
    this.expensesTotalPages = result.pageCount;
    this.expensesFirstItemOnPage = result.firstRowOnPage;
    this.expensesLastItemOnPage = result.lastRowOnPage;

    this.expensesCurrentPage = result.currentPage;

    this.expensesListedPages = [];

    let startPage = this.expensesCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.expensesCurrentPage + 2;
    while (maxPage > this.expensesTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.expensesListedPages.push(i);
    }

    if (!result.results.length) {
      this.expensesTotalPages = 1;
      this.expensesCurrentPage = 1;
      this.expensesFirstItemOnPage = 0;

      this.expensesListedPages = [];
      this.expensesListedPages.push(1);
    }
  }

  renderPaginatorLiabilities(result: PagedList<any>) {
    this.liabilitiesTotalItems = result.rowCount;
    this.liabilitiesTotalPages = result.pageCount;
    this.liabilitiesFirstItemOnPage = result.firstRowOnPage;
    this.liabilitiesLastItemOnPage = result.lastRowOnPage;

    this.liabilitiesCurrentPage = result.currentPage;

    this.liabilitiesListedPages = [];

    let startPage = this.liabilitiesCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.liabilitiesCurrentPage + 2;
    while (maxPage > this.liabilitiesTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.liabilitiesListedPages.push(i);
    }

    if (!result.results.length) {
      this.liabilitiesTotalPages = 1;
      this.liabilitiesCurrentPage = 1;
      this.liabilitiesFirstItemOnPage = 0;

      this.liabilitiesListedPages = [];
      this.liabilitiesListedPages.push(1);
    }
  }

  renderPaginatorStructured(result: PagedList<any>) {
    this.structuredTotalItems = result.rowCount;
    this.structuredTotalPages = result.pageCount;
    this.structuredFirstItemOnPage = result.firstRowOnPage;
    this.structuredLastItemOnPage = result.lastRowOnPage;

    this.structuredCurrentPage = result.currentPage;

    this.structuredListedPages = [];

    let startPage = this.structuredCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.structuredCurrentPage + 2;
    while (maxPage > this.structuredTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.structuredListedPages.push(i);
    }

    if (!result.results.length) {
      this.structuredTotalPages = 1;
      this.structuredCurrentPage = 1;
      this.structuredFirstItemOnPage = 0;

      this.structuredListedPages = [];
      this.structuredListedPages.push(1);
    }
  }

  renderPaginatorStructuredOrder(result: PagedList<any>) {
    this.structuredOrderTotalItems = result.rowCount;
    this.structuredOrderTotalPages = result.pageCount;
    this.structuredOrderFirstItemOnPage = result.firstRowOnPage;
    this.structuredOrderLastItemOnPage = result.lastRowOnPage;

    this.structuredOrderCurrentPage = result.currentPage;

    this.structuredOrderListedPages = [];

    let startPage = this.structuredOrderCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.structuredOrderCurrentPage + 2;
    while (maxPage > this.structuredOrderTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.structuredOrderListedPages.push(i);
    }

    if (!result.results.length) {
      this.structuredOrderTotalPages = 1;
      this.structuredOrderCurrentPage = 1;
      this.structuredOrderFirstItemOnPage = 0;

      this.structuredOrderListedPages = [];
      this.structuredOrderListedPages.push(1);
    }
  }

  // #endregion renderPaginatorBoleta()
}
